import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const ExclamationMarkFilled = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsxs("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22C17.5049 22 22 17.495 22 12C22 6.50495 17.5049 2 12 2C6.49505 2 2 6.49505 2 12C2 17.5049 6.50495 22 12 22Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 13.5503V6.82031",
                stroke: "white",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 16.1504C12.2761 16.1504 12.5 16.3742 12.5 16.6504C12.5 16.9265 12.2761 17.1504 12 17.1504C11.7239 17.1504 11.5 16.9265 11.5 16.6504C11.5 16.3742 11.7239 16.1504 12 16.1504Z",
                fill: "white",
                stroke: "white"
            })
        ]
    });
};
